import React, { Component } from "react";
import "..//Css/Registration.css";
import Json from "..//dummy_data/users.json";
import Header from "./Header";
export default class Registration extends Component {
  render() {
    function checkPassword() {
      let password = document.getElementById("passwordInput"),
        repeatPassword = document.getElementById("repeatPasswordInput");

      if (password.value !== repeatPassword.value) {
        password.setCustomValidity("Passwords must match!");
      } else {
        password.setCustomValidity("");
      }
    }
    function checkEmail() {
      let email = document.getElementById("email");
      for (let key = 0; key < Json.length; key++) {
        if (Json[key].email === email.value) {
          email.setCustomValidity("This email is busy ,enter another one");
        }
      }
    }
    return (
      <>
        <Header />
        <div>
          <form id="reg-form">
            <p>
              <input
                type="text"
                id="name"
                placeholder="Введите имя"
                required
                minlength="6"
              ></input>
            </p>
            <p>
              <input
                type="text"
                id="surname"
                placeholder="Введите фамилию"
                onchange="checkLenght()"
                required="Обязательное поле для заполнения"
                minlength="6"
              ></input>
            </p>
            <p>
              <input
                type="email"
                id="email"
                placeholder="Введите e-mail"
                required="Обязательное поле для заполнения"
                onChange={checkEmail}
              ></input>
            </p>

            <p>
              <input
                type="password"
                id="repeatPasswordInput"
                placeholder="Repeat password"
                required
              />
            </p>
            <p>
              {" "}
              <input
                type="password"
                id="passwordInput"
                name="Password"
                placeholder="Enter password"
                required
                onClick={checkPassword}
              />
            </p>
            <p>
              <input
                className="reg-btn-submit"
                type="submit"
                value="Submit"
              ></input>
              <input type="reset" value="Reset"></input>
            </p>
          </form>
        </div>
      </>
    );
  }
}
